export default function TalentContentContainer({ children }) {
  return (
    <div style={{ maxWidth: '980px', margin: '0 auto', width: '100%' }}>
      {children}
    </div>
  );
}
